import axios from "../plugins/parseAxios";

export class MarketSettingAPI {
  static getAccountingCharts(projectId) {
    return axios.post("functions/getAccountingCharts", {
      projectId
    });
  }
  static createMarketSetting(formData) {
    return axios.post("functions/createMarketSetting", formData);
  }
  static updateMarketSetting(formData) {
    return axios.post("functions/updateMarketSetting", formData);
  }
}